export default __webpack_public_path__ + "static/media/adobe-tech-2.247b297c.webp";